// import { printHelp } from "../util";

export function ada(cmd) {
  // console.log(cmd);
  const flags = cmd.flags;

  // console.dir("2232323");
  // console.dir(flags);
}
